<template>
  <a-modal
    :title="modalTit"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :centered="true"
    :width="510"
    :mask-closable="false"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    class="clue-follow-modal"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form
      class="finish-follow-form"
      :form="form"
    >
      <a-form-item label="跟进记录">
        <a-input
          v-decorator="['content', {
            initialValue:''
          }]"
          type="textarea"
          placeholder="添加跟进记录"
          class="input"
        />
      </a-form-item>
      <files
        v-if="visible"
        ref="fileUpload"
        :data="fileData"
        class="file-item"
        @change="handleChangeFile"
      />

      <a-form-item
        v-if="isShowTime"
        label="下次跟进"
      >
        <a-date-picker
          v-decorator="['followtime', {
            rules: [{ required: Object.keys(followData).length > 0 && followData.field , message: '请选择下次跟进时间'}],
            initialValue: followData.time ? $moment(followData.time , dateFormat) :null
          }]"
          :disabled-date="disabledDate"
          placeholder="下次跟进时间"
          @change="onChangeTime"
        />
        <p
          v-if="followData.field"
          class="follow-data-list"
        >
          {{ `${followData.field}：${followData.value}` }}
        </p>
      </a-form-item>
    </a-form>
    <gallery />
  </a-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Files from '@/pc/inquery/formItem/File'
import Gallery from '@/components/pc/Gallery'

export default {
  components: {
    Files,
    Gallery
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => { }
    },
    followData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      dateFormat: 'YYYY-MM-DD',
      confirmLoading: false,
      followtime: null,
      file: []
    }
  },
  computed: {
    ...mapState('inquery/clue', ['followLogs']),
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    },
    modalTit () {
      return '完成跟进' // this.$t('message["1621"]')
    },
    fileData () {
      return {
        fieldkey: 'file',
        fieldtype: 'file',
        hideLimitText: true,
        labelname: '',
        // isneeded: this.permissionInfo.is_pic_followup,
        accept: '*',
        fieldvalue: []
      }
    },
    isShowTime () {
      return this.followLogs['view-data'] === 'yes'
    }
  },
  watch: {
    visible (val) {
      this.isVisible = val
      if (val) {
        // this.followtime = this.followData.time
      }
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('inquery/clue', ['finishFollow']),
    hide () {
      this.$emit('update:visible', false)
    },
    async handleOk () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          if (this.confirmLoading) return

          this.confirmLoading = true
          if (this.isShowTime) {
            values.followtime = this.followtime ? this.followtime : this.followData.time
          }
          const chain = await this.finishFollow()
          chain
            .setForm(this.form)
            .params({
              ...this.data,
              ...values,
              file: this.file
            })
            .onNetSuccess(raw => {
              this.confirmLoading = false
              this.$emit('finishHandle')
            })
            .onSuccess(payload => {
              this.handleCancel()
            })
            .fetch()
        }
      })
    },
    onChangeTime (time, timestring) {
      this.followtime = timestring
    },
    handleCancel () {
      this.hide()
      this.form.resetFields()
      this.reason = ''
      this.confirmLoading = false
      this.file = []
      this.fileData.fieldvalue = []
    },
    handleChangeFile (val) {
      this.file = val
    },
    disabledDate (val) {
      return val && val < this.$moment().startOf('day')
    }
  }
}
</script>

<style lang="scss" scoped>
.finish-follow-form::v-deep{
  max-height: 400px;
  overflow-y: auto;
    .ant-row {
        padding-left: 100px;
        .ant-form-item-label {
          float: left;
          width: 90px;
          margin-left: -100px;
          color: #666;
          text-align: right;
        }
        .ant-form-item-control-wrapper {
          float: left;
          width: 100%;
          textarea{
            height: 120px;
          }
        }
        &.file-item{
          margin: -8px 0 24px;
        }
      }
  }
</style>
<style lang="scss">
.clue-follow-modal{
  width: 510px !important;
}
</style>
